import {
  affirmSendInvitation,
  getRadSelectInfo,
  addCustomerSelected,
  getRadResultInfo
} from '@/api/radThree'

const state = {
  styleArr: [],
  styleArrChange: []
}

const mutations = {
  CHANGE_STYLE_ARR(state, val) {
    state.styleArr = val
  },
  STYLE_ARR_CHANGE(state, val) {
    state.styleArrChange = val
  }
}

const actions = {
  // // 01-获取方案颜色任务列表
  // getRadList({ state, commit }, data) {
  //   return new Promise((resolve, reject) => {
  //     getRadList(data).then(response => {
  //       resolve(response.data)
  //     }).catch(error => {
  //       reject(error)
  //     })
  //   })
  // },
  // 02-确认发送rad3邀请函
  affirmSendInvitation({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      affirmSendInvitation(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 03-获取方案颜色选项详情
  getRadSelectInfo({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getRadSelectInfo(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 03-获取方案颜色选项详情
  addCustomerSelected({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      addCustomerSelected(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 05-获取评测结果
  getRadResultInfo({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getRadResultInfo(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
